import React, { Component } from 'react';
import { FormLabeledItem, Input, ItemChooser, CheckBox, TextArea, SelectList, Button, FormDataObj } from '../../../components/FormUI';
import User from '../../../api/User';

import { Grid, Segment } from 'semantic-ui-react'

import './UserForm.css';
import PhysicianService from '../../../api/services/PhysicianService';
import DoctorTypeList from '../../../components/selectlists/DoctorTypeList';


export default class DrMiniForm extends Component{
    
    state = {errors:{}};
    form = {};
    componentWillMount(){
        this.form = new FormDataObj(new User(this.props.user || {}));
    }

    submit(){

        let errors = this.form.getErrorState();
        if(errors != null){
            this.setState({errors:errors});
            return;
        }

        let userService = this.props.service || PhysicianService;
        userService.Save(this.form.data).then((user) => {
            for(let p in user){
                this.props.user[p] = user[p];
            }
            this.setState({saving:false});
            if(this.props.onSaved){
                this.props.onSaved(new User(user));
            }
        })
        this.setState({saving:true, errors:{}});
    }
    render(){        
        //console.log("UserForm:", this.form);

        return(
            <div className='user-form-mini'>
                <div className='table hmax layout-fixed align-bottom'>
                    <div>
                        <div><Input placeholder='First Name' name='firstName' form={this.form} error={this.state.errors['firstName']} /></div> 
                        <div><Input placeholder='Last Name' name='lastName' form={this.form} /></div>
                    </div>
                    <div>
                        <div><Input name='homePhone' form={this.form} placeholder='Home Phone'/></div>
                        <div><Input name='workPhone' form={this.form} placeholder='Work Phone'/></div>
                    </div>
                    <div>
                        <div><Input name='cellPhone' form={this.form} placeholder='Cell Phone'/></div>
                        <div><Input type='email' name='email' form={this.form} placeholder='Email'/></div>
                    </div>
                    <div>
                        <div><DoctorTypeList form={this.form} name='typeOfWork' value='General Practitioner' /></div>                        
                        <div><Button className='green' caption='Save' onClick={() => this.submit()} isBusy={this.state.saving} /></div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Clients/forms/DrMiniForm.js